export default "__VITE_ASSET__D_v7XZDd__"